//import axios from "axios";
import ApiService from "@/core/services/api.service";

export const OBTENER_RESULTADOS_MUNI = "obtenerResultadosMunicipalidad";
export const REGISTRAR_RESULTADOS_MUNI = "registrarResultadosMuni";
export const OBTENER_REPORTE_RESULTADOS_MUNI ="obtenerReporteResultados";
export const OBTENER_REPORTE_CATEGORIAS_RESULTADOS_MUNI ="obtenerReporteCategoriasResultados";



// mutation types
export const SET_RESULTADOS_MUNI = "setResultadosMuni";


const state = {
    resultadosMuni:[],
}

// actions

const actions = {


    /**
     * Obtener los resutados de la municipalidad
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    async [OBTENER_RESULTADOS_MUNI](context, datos) {

        return new Promise(resolve => {
           
            ApiService.query(`apiconsume/obtener?endpoint=api/Resultados/${datos.municipioId}/${datos.indiceId}/${datos.periodoId}`, '')
                .then(({ data }) => {
                    if(data.status===200){
                        context.commit(SET_RESULTADOS_MUNI, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },



    /**
     * Registrar los resultados de una municipalidad por boleta
     * @param {*} context 
     * @param {*} datosResultados 
     * @returns 
     */
    async [REGISTRAR_RESULTADOS_MUNI](context, datosResultados){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Resultados`, datosResultados)
                .then(({ data }) => {
                    if(data.status===200){
                        context.commit(SET_RESULTADOS_MUNI, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },


    
    /**
     * Obtener reportes de resultados (para gráficas)
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
     async [OBTENER_REPORTE_RESULTADOS_MUNI](context, datos) {

        return new Promise(resolve => {
           
            ApiService.query(`apiconsume/obtener?endpoint=api/Resultados/reporte/${datos.periodoId}/${datos.deptoId}/${datos.municipioId}/${datos.indiceId}`, '')
                .then(({ data }) => {
                    if(data.status===200){
                        context.commit(SET_RESULTADOS_MUNI, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },


    /**
     * Obtener reportes de categorias de resultados (para gráficas)
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
     async [OBTENER_REPORTE_CATEGORIAS_RESULTADOS_MUNI](context, datos) {

        return new Promise(resolve => {
           
            ApiService.query(`apiconsume/obtener?endpoint=api/Resultados/reporte/categorias/${datos.periodoId}/${datos.deptoId}/${datos.municipioId}/${datos.indiceId}`, '')
                .then(({ data }) => {
                    if(data.status===200){
                        context.commit(SET_RESULTADOS_MUNI, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },
}


const mutations = {
    [SET_RESULTADOS_MUNI](state, data) {
        state.resultadosMuni = data;
    },
}


export default {
    state,
    actions,
    mutations
}